import type { OvertimeRequestSummaryResult } from "@/modules/hr/overtime/domain/types";
import { Card, CardContent } from "@devhop/ui";
import { CalendarIcon, CheckCircle2, Hourglass } from "lucide-react";

type OTRequestSummaryCardsProps = {
  data: OvertimeRequestSummaryResult | undefined;
  isLoading?: boolean;
};

function formatNextDate(dateStr: string | null): string {
  if (!dateStr) return "—";
  const d = new Date(dateStr);
  return d.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
  });
}

export function OTRequestSummaryCards({
  data,
  isLoading,
}: OTRequestSummaryCardsProps) {
  const approvedHours = data?.approvedHours ?? 0;
  const pendingCount = data?.pendingCount ?? 0;
  const nextScheduled = data?.nextScheduledDate ?? null;

  if (isLoading) {
    return (
      <div className="mb-6 grid gap-4 md:grid-cols-3">
        {[1, 2, 3].map((i) => (
          <div key={i} className="animate-pulse rounded-xl border bg-card p-6">
            <div className="h-4 w-24 rounded bg-muted" />
            <div className="mt-2 h-8 w-32 rounded bg-muted" />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="mb-6 grid gap-4 md:grid-cols-3">
      <Card>
        <CardContent className="flex items-center gap-4">
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-muted text-muted-foreground">
            <CheckCircle2 className="h-5 w-5" />
          </div>
          <div>
            <p className="font-medium text-muted-foreground text-sm">
              OT ທີ່ອະນຸມັດ
            </p>
            <p className="font-semibold text-xl">
              {approvedHours.toFixed(1)} ຊມ.
            </p>
          </div>
        </CardContent>
      </Card>
      <Card>
        <CardContent className="flex items-center gap-4">
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-muted text-muted-foreground">
            <Hourglass className="h-5 w-5" />
          </div>
          <div>
            <p className="font-medium text-muted-foreground text-sm">
              OT ທີ່ຍົກເລີກ
            </p>
            <p className="font-semibold text-xl">{pendingCount}</p>
          </div>
        </CardContent>
      </Card>
      <Card>
        <CardContent className="flex items-center gap-4">
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-muted text-muted-foreground">
            <CalendarIcon className="h-5 w-5" />
          </div>
          <div>
            <p className="font-medium text-muted-foreground text-sm">
              OT ທີ່ກຳລັງດຳເນີນການ
            </p>
            <p className="font-semibold text-xl">
              {formatNextDate(nextScheduled)}
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
